module.exports = __webpack_public_path__ + "img/livre_bibliotheque.b292470f.jpg";